import * as React from 'react';
import * as icons from './Icons';
import { useRenderers } from '../renderProps';
const overridedIcons = {};
Object.entries(icons).forEach(([name, icon]) => {
    overridedIcons[name] = (props) => {
        const renderers = useRenderers();
        const componentName = name;
        if (renderers.hasOwnProperty(componentName) && renderers[componentName]) {
            const Component = renderers[componentName];
            return React.createElement(Component, Object.assign({}, props));
        }
        const DefaultIcon = () => icon;
        return React.createElement(DefaultIcon, Object.assign({}, props));
    };
});
export { overridedIcons };
export * from './Icons';
